export default "<div class=\"text-center\">\n  <div class=\"copyright\">\n     Copyright &#169; 2021 Gotadi. All rights reserved\n  </div>\n</div>\n"